import React from 'react';

type HomePageProps = {
  notificationOpen?: boolean;
  onCloseNotifications?: () => void;
  children: React.ReactNode;
};

export function HomePage({
  notificationOpen = false,
  onCloseNotifications,
  children
}: HomePageProps) {
  return (
    <main className={`home-market${notificationOpen ? ' home-market--notif-open' : ''}`}>
      {notificationOpen && onCloseNotifications ? (
        <button
          type="button"
          className="home-market__notif-scrim"
          aria-label="Закрыть уведомления"
          onClick={onCloseNotifications}
        />
      ) : null}
      {children}
    </main>
  );
}

type HomeHeaderProps = {
  balance: string;
  attentionCount: number;
  notificationOpen: boolean;
  bellRef: React.RefObject<HTMLDivElement | null>;
  onToggleNotifications: () => void;
};

export function HomeHeader({
  balance,
  attentionCount,
  notificationOpen,
  bellRef,
  onToggleNotifications
}: HomeHeaderProps) {
  return (
    <header className="home-market__topbar">
      <div className="home-market__brand-col">
        <h1 className="home-market__brand">FreelanCYX</h1>
        <p className="home-market__subtitle">Биржа заказов в Telegram</p>
      </div>
      <div className="home-market__top-actions">
        <div className="home-market__bell-wrap" ref={bellRef}>
          <button
            type="button"
            className="home-market__bell"
            aria-expanded={notificationOpen}
            aria-label="Требует внимания"
            onClick={onToggleNotifications}
          >
            <span aria-hidden>🔔</span>
            {attentionCount > 0 ? (
              <span className="home-market__bell-badge">{attentionCount > 9 ? '9+' : attentionCount}</span>
            ) : null}
          </button>
        </div>
        <div className="home-market__balance" title="Баланс в приложении">
          <span aria-hidden>💵</span>
          <span>{balance}</span>
        </div>
      </div>
    </header>
  );
}

export type HomeQuickAction = {
  id: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
};

export function HomeQuickActions({ actions }: { actions: HomeQuickAction[] }) {
  return (
    <nav className="home-grid home-grid--mock" aria-label="Быстрые действия">
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className={`home-mock-tile home-mock-tile--${action.id === 'favorites' ? 'fav' : action.id}`}
          onClick={action.onClick}
        >
          <span className="home-mock-tile__icon" aria-hidden>{action.icon}</span>
          <span className="home-mock-tile__label">{action.label}</span>
        </button>
      ))}
    </nav>
  );
}

type HomeSectionHeaderProps = {
  title: React.ReactNode;
  id?: string;
  className?: string;
  actionLabel?: string;
  onAction?: () => void;
  actions?: React.ReactNode;
};

export function HomeSectionHeader({
  title,
  id,
  className = '',
  actionLabel,
  onAction,
  actions
}: HomeSectionHeaderProps) {
  return (
    <div id={id} className={`home-section-title${className ? ` ${className}` : ''}`}>
      <span>{title}</span>
      {actions ?? (actionLabel && onAction ? (
        <button type="button" onClick={onAction}>{actionLabel}</button>
      ) : null)}
    </div>
  );
}

export type SegmentedTab<T extends string> = {
  id: T;
  label: string;
};

export function SegmentedTabs<T extends string>({
  label,
  value,
  tabs,
  onChange,
  className = ''
}: {
  label: string;
  value: T;
  tabs: readonly SegmentedTab<T>[];
  onChange: (value: T) => void;
  className?: string;
}) {
  return (
    <div className={`home-discover-tabs${className ? ` ${className}` : ''}`} role="tablist" aria-label={label}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={value === tab.id}
          className={`home-discover-tabs__btn${value === tab.id ? ' home-discover-tabs__btn--on' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
